<template>
<div class="chapter">
<div class="inner_page">
<p class="p-p7">Published by Sunbury Press, Inc.</p>
<p class="p-p7">105 South Market Street</p>
<p class="p-p7">Mechanicsburg, Pennsylvania 17055</p>
<div class="p-p7">
<div class="g-fr3"><img alt="" class="calibre3" src="Images/logo.jpg"/></div>
</div>
<p class="p-p8"><br/>
  www.sunburypress.com</p>
<p class="whitespace2"> </p>
<p class="p-p9">NOTE: This is a work of fiction. Names, characters, places and incidents are the product of the author's imagination or are used fictitiously, and any resemblance to actual persons, living or dead, business establishments, events or locales is entirely coincidental.</p>
<p class="whitespace2"> </p>
<p class="p-p10">Copyright © 2015 by Keith Rommel.</p>
<p class="p-p10">Images © 2015 by Keith Rommel.</p>
<p class="p-p11">Cover Copyright © 2015 by Sunbury Press, Inc.</p>
<p class="p-p12">Sunbury Press supports copyright. Copyright fuels creativity, encourages diverse voices, promotes free speech, and creates a vibrant culture. Thank you for buying an authorized edition of this book and for complying with copyright laws by not reproducing, scanning, or distributing any part of it in any form without permission. You are supporting writers and allowing Sunbury Press to continue to publish books for every reader. For information contact Sunbury Press, Inc., Subsidiary Rights Dept., 105 S. Market St., Mechanicsburg, PA 17055 USA or legal@sunburypress.com.</p>
<p class="whitespace2"> </p>
<p class="p-p12">For information about special discounts for bulk purchases, please contact Sunbury Press Orders Dept. at (855) 338-8359 or orders@sunburypress.com.</p>
<p class="whitespace2"> </p>
<p class="p-p12">To request one of our authors for speaking engagements or book signings, please contact Sunbury Press Publicity Dept. at publicity@sunburypress.com.</p>
<p class="whitespace2"> </p>
<p class="p-p13">ISBN: 978-1-62006-652-2 (Trade Paperback)</p>
<p class="p-p13">ISBN: 978-1-62006-653-9 (Mobipocket)</p>
<p class="whitespace2"> </p>
<p class="p-p14">Library of Congress Control Number: 2015954540</p>
<p class="whitespace2"> </p>
<p class="p-p15">FIRST SUNBURY PRESS EDITION: October <span class="s-t2">2015</span></p>
<p class="whitespace2"> </p>
<p class="p-p16">Product of the United States of America</p>
<p class="p-p15">0 1 1 2 3 5 8 13 21 34 55</p>
<p class="whitespace2"> </p>
<p class="p-p15">Set in Bookman Old Style</p>
<p class="p-p15">Designed by Crystal Devine</p>
<p class="p-p15">Cover by Amber Rendon</p>
<p class="p-p15">Edited by Jennifer Melendrez</p>
<div class="p-p17" style="text-align: center;">
<div class="g-fr4"><img alt="" class="calibre2" src="Images/100000000000006400000064711937F5.jpg"/></div>
</div>
<p class="whitespace2"> </p>
<p class="p-p18">Continue the Enlightenment!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?104cc85f